import { GraphicEngine } from "../../../src/GraphicEngine";
import { Component } from '../../../src/Component';
class Animation extends GraphicEngine {
    constructor(selector, options) {
        super(selector, options);
        if (this.length == 0)
            return;
        this.context = this.get(0).getContext('2d', {
            alpha: this.options.alpha
        });
        this.setup();
    }
    resize(dimensions) {
        super.resize(dimensions);
        this.bufferDimensions = {
            width: this.options.width * this.options.pixelRatio,
            height: this.options.height * this.options.pixelRatio
        };
    }
    setup() {
        this.imageData = this.context.createImageData(this.bufferDimensions.width, this.bufferDimensions.height);
        this.buffer = new Uint32Array(this.imageData.data.buffer);
        this.alphaLimit = .5;
        this.waveCounter = 0;
        const increase = Math.PI * 2 / 100;
        setInterval(() => {
            this.alphaLimit = Math.sin(this.waveCounter) / 2 + .5;
            this.waveCounter += increase;
        }, 40);
        setInterval(() => {
            let len = this.buffer.length - 1;
            while (len--)
                this.buffer[len] = Math.random() < this.alphaLimit ? 0xff000000 : 0x0000000;
        }, 40);
    }
    clear() {
        if (this.options.clear && this.context)
            this.context.clearRect(0, 0, this.bufferDimensions.width, this.bufferDimensions.height);
    }
    draw() {
        this.context.putImageData(this.imageData, 0, 0);
    }
}
export class Animation2D extends Component {
    constructor() {
        super('Animation2D', true);
    }
    async init() {
        await super.init();
        const canvas2D = new Animation('#canvas-2d', { alpha: true, clear: false, width: 640, height: 480, pixelRatio: 1 });
        this.success();
    }
}
